import { render, staticRenderFns } from "./contact-way.vue?vue&type=template&id=6176eee8&scoped=true&"
import script from "./contact-way.vue?vue&type=script&lang=js&"
export * from "./contact-way.vue?vue&type=script&lang=js&"
import style0 from "./contact-way.vue?vue&type=style&index=0&id=6176eee8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176eee8",
  null
  
)

export default component.exports